import Vue from "vue";

export default {
    SAVE_ZONE_CUSTOM_DESIGN(state, payload) {
        const index = state.actualDesign.findIndex(({ id, posicion }) => id === payload.id && posicion === payload.posicion);
        if (index !== -1) {
            // state.actualDesign[index] = { ...payload };
            Vue.set(state.actualDesign, index, payload);
        } else {
            state.actualDesign.push(payload);
        }
    },
    DELETE_ZONE_CUSTOM_DESIGN(state, payload) {
        const index = state.actualDesign.findIndex(({ id, posicion }) => id === payload.id && posicion === payload.posicion);
        if (index !== -1) {
            state.actualDesign.splice(index, 1);
        }
        else {
            console.warn("No hemos encontrado que borrar")
        }
    },
    DELETE_ALL_ZONE_CUSTOM_DESIGN(state) {
        state.actualDesign = [];
    },
    UPDATE_DESIGN_COLOR(state, payload) {
        state.actualDesign = [...payload]
    },
    ADD_BOCETO_REPETICION(state, payload) {
        if (isNaN(payload?.id)) {
            console.error("No se ha proporcionado un identificador de zona correcto");
            return;
        }
        let actualBoceto = state.bocetosRepeticion.find(b => b.id == payload.id);
        if (actualBoceto) {
            actualBoceto.value = payload.value;
        } else {
            state.bocetosRepeticion.push(payload);
        }
    },
    DELETE_BOCETO_REPETICION(state, payload) {
        if (!isNaN(payload)) {
            return;
        }
        state.bocetosRepeticion = state.bocetosRepeticion.filter(b => b.id != payload);
    },
    UPDATE_ZONES(state, payload) {
        // Usamos Vue.set para asegurarnos de que la reactividad funcione correctamente
        Vue.set(state, 'activeZonesId', payload);
    },
    UPDATE_IMG_INFO_CANVAS_3D(state, payload) {
        if (payload) {
            Vue.set(state, 'imgInfoCanvas3d', payload);
        } else {
            Vue.set(state, 'imgInfoCanvas3d', {});
        }
    },
    // UPDATE_PARAMS_HEIGHT_AND_WIDTH_WITHOUT_UPDATE_PRICE(state, { id, ancho, alto }) {
    //     const index = state.actualDesign.findIndex(r => r.id === id);
    //     if (index !== -1) {
    //         const atributos = JSON.parse(state.actualDesign[index].params.atributos);

    //         // Atributos debe ser un array, y contener al menos un elemento
    //         if (!Array.isArray(atributos) || atributos.length === 0) {
    //             return;
    //         }

    //         if (atributos[0]) {
    //             if (atributos[0].maxWidth) {
    //                 atributos[0].maxWidth = ancho;
    //             }

    //             if (atributos[0].maxHeight) {
    //                 atributos[0].maxHeight = alto;
    //             }

    //             state.actualDesign[index].params.atributos = JSON.stringify(atributos);
    //         }
    //     }
    // },
    ADD_LOADING_DESIGN(state) {
        state.loadingDesign++;
    },
    REMOVE_LOADING_DESIGN(state) {
        state.loadingDesign--;

        if (state.loadingDesign < 0) {
            state.loadingDesign = 0;
        }
    },
    UPDATE_ACTIVE_ZONE_3D(state, payload) {
        Vue.set(state, 'activeZone3D', payload);
    },
    ROTATE_LOGO_STATE(state, payload) {
        state.rotateDesignState = payload;

        Vue.set(state.rotateDesignState, payload.id, payload.rotate);
    },
}